export default function normalizeSeats(seats) {
  if (!seats) return;

  const res = seats
    .split(',') // Розділити рядок за комою
    .map(seat => seat.trim()) // Видалити пробіли перед і після числа
    .filter(seat => seat !== '') // Видалити пусті значення
    .map(Number) // Перетворити рядки на числа
    .join(', ');

  return res;
}
